import { LuFileClock } from "react-icons/lu";
import { SiGoogleclassroom } from "react-icons/si";
import { IoMdNotifications } from "react-icons/io";
import { MdRocketLaunch } from "react-icons/md";

// Sidebar Items
const TeacherSidebarItems = [

    // {
    //     icon: IoMdNotifications,
    //     heading: 'Notice'
    // },

    {
        icon: SiGoogleclassroom,
        heading: 'lectures'
    }

    // {
    //     icon: LuFileClock,
    //     heading: 'Tests'
    // },
];

export default TeacherSidebarItems;